import { render, staticRenderFns } from "./LeadsplusReport.vue?vue&type=template&id=5892405a&scoped=true&lang=pug"
import script from "./LeadsplusReport.vue?vue&type=script&lang=js"
export * from "./LeadsplusReport.vue?vue&type=script&lang=js"
import style0 from "./LeadsplusReport.vue?vue&type=style&index=0&id=5892405a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5892405a",
  null
  
)

export default component.exports